import { PRICE_BANDS } from "@/lib/pricing";
import type { PriceBand } from "@/types/work";

export const contentTypeLabels = {
  video: "動画",
  manga: "漫画",
  ebook: "電子書籍",
  book: "書籍",
  doujin: "同人",
  voice: "音声",
  cg: "CG",
  game: "ゲーム",
  goods: "グッズ",
  other: "その他の作品",
};

export const audienceLabels = {
  male: "男性向け",
  female: "女性向け",
  common: "共通",
  unclassified: "未分類",
};

export const genreMatchLabels = {
  and: "すべて含む（AND）",
  or: "いずれか（OR）",
};

export const priceBandLabels = Object.fromEntries(
  PRICE_BANDS.map((band) => [band.id, band.shortLabel]),
) as Record<PriceBand, string>;

export const sortLabels = {
  relevance: "関連度順",
  popular: "人気順",
  newest: "発売日が新しい順",
  oldest: "発売日が古い順",
  priceAsc: "価格が安い順",
  priceDesc: "価格が高い順",
  rating: "レビュー評価順",
};

export const rankingTypeLabels = {
  daily: "デイリー",
  weekly: "ウィークリー",
  monthly: "マンスリー",
  fresh: "新着注目",
  rating: "レビュー評価",
  editorial: "おすすめ",
};

export const modeNotes = [
  "ランキング・検索結果・カテゴリ・特集はモードに連動して切り替わります。",
  "選択したモードはこのブラウザに保存され、次回訪問時に復元されます。",
  "性別の自動判定は行いません。切り替えはいつでも手動で行えます。",
];